import { render, staticRenderFns } from "./firstHome.vue?vue&type=template&id=50bab73d&scoped=true&"
import script from "./firstHome.vue?vue&type=script&lang=js&"
export * from "./firstHome.vue?vue&type=script&lang=js&"
import style0 from "./firstHome.vue?vue&type=style&index=0&id=50bab73d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bab73d",
  null
  
)

export default component.exports